// The strings in this function come from the application_source_issue_types table
// and are assigned by the facebook and indeed `watcher-job`s
export const EXTERNAL_APPLICATION_SOURCE_ISSUE_METADATA = (sourceIssue: string) => {
  switch (sourceIssue) {
    case 'FACEBOOK_DISCRIMINATION':
      return {
        displayName: 'Gender-Specific Language',
        description:
          'Facebook Jobs does not allow job titles or descriptions that imply the job is for one gender over another. We most often see that these jobs end in "man", such as Journeyman, Foreman, etc. Team Engine has no control over these restrictions. See our recommendations for how to make your jobs compliant',
        linkText: 'here',
        linkUrl:
          'https://help.teamengine.io/article/68-common-issues-with-jobs-not-posting-on-facebook',
      };
    case 'FACEBOOK_ILLEGAL':
    case 'FACEBOOK_PERSONAL_INFO':
    case 'FACEBOOK_MISLEADING':
    case 'FACEBOOK_SEXUAL':
    case 'FACEBOOK_ADULT_CONTENT':
    case 'FACEBOOK_MULTILEVEL_MARKETING':
    case 'FACEBOOK_DRUGS':
    case 'FACEBOOK_IMPERSONATION':
      return {
        displayName: 'Job Not Posting',
        description:
          'Your job is not publishing to Facebook Jobs and they have flagged it as misleading, illegal, or inappropriate. This is out of Team Engine’s control and is often an error. Please make an edit to your job description to trigger a review by Facebook.',
        linkText: '',
        linkUrl: '',
      };
    // DR 10/14/21: This case isn't currently possible. Not only is it not in the
    // application_source_issue_types table but we also don't submit incomplete jobs. We instead
    // show the info missing error on the job.
    case 'MISSING_INFORMATION':
      return {
        displayName: 'Job Not Posting',
        description:
          'Your job is not publishing to Facebook Jobs because it is missing information that Facebook requires. Please update your job details.',
        linkText: '',
        linkUrl: '',
      };
    case 'INDEED_NO_VIEWS':
      return {
        displayName: 'No Views',
        description:
          'This job has been published for at least 24 hours and has no views on Indeed. This can mean that either the job is in a remote area and traffic is very low, or Indeed has filtered the job for some reason.',
        linkText: 'Learn more',
        linkUrl:
          'https://help.teamengine.io/article/67-common-issues-with-jobs-not-posting-on-indeed',
      };
    case 'FACEBOOK_GENERIC_DEFAULT':
    case 'NO_REASON_SPECIFIED':
    case 'OTHER':
    default:
      return {
        displayName: 'Job Not Posting',
        description:
          'Your job is not publishing to Facebook Jobs, but Facebook did not provide a specific reason why. Learn more about potential reasons for this',
        linkText: 'here',
        linkUrl:
          'https://help.teamengine.io/article/68-common-issues-with-jobs-not-posting-on-facebook',
      };
  }
};
